import { filter } from 'lodash';
import { useEffect, useState, useMemo } from 'react';
import {
  Table,
  Stack,
  Avatar,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  Box,
  Link,CircularProgress,
  Tooltip,
  FormControl,
  MenuItem,
  Grid,
  InputLabel,
  Select
} from '@mui/material';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/user';
import Iconify from '../../components/Iconify';
import ClientReport from './ClientReport';
import ClientMoreMenu from './ClientMoreMenu';
import ClientAlert from './ClientAlert';
import client from '../../api/clients';
import { getColor } from '../../utils/color';
import ClientListHead from './ClientListHead';
import { MdOutlineImageNotSupported } from 'react-icons/md';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';



// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function formatCreatedOn(value) {
    if (!value) return '';

    return String(value).replace(/(\d{2}:\d{2}:\d{2})\.\d+/, '$1');
}

function addCacheVersion(url, version) {
    if (!url || !version) return url;

    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${version}`;
}


export default function ClientList({ total, active, inactive, handleMoremenu, handleDialog, reloadClientsData, removeClientFromState, tab, isLoaded, isReseller, logoCacheVersion }) {

    const [page, setPage] = useState(0);
    const [order, setOrder] = useState('asc');
    const [selected, setSelected] = useState([]);
    const [orderBy, setOrderBy] = useState('name');
    const [filterName, setFilterName] = useState('');
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [clients, setClient] = useState(total);
    const [isNotFound, setNotFound] = useState(false)
    const [imageError, setImageError] = useState(false)
    const [logoError, setLogoError] = useState(false)
    const [environmentType, setEnvironmentType] = useState('production');
    const [statusFilter, setStatusFilter] = useState("all");
    
    let TABLE_HEAD = [
    { id: 'name', label: 'S No', alignRight: false, tag: '' },
    { id: 'company', label: 'Client Id', alignRight: false, tag: 'ID' },
    { id: 'clientName', label: 'Client Name', alignRight: false, tag: 'displayname' },
    { id: 'Location', label: 'Location', alignRight: false, tag: 'Location' },
    { id: 'EnvironmentType', label: 'Environment Type', alignRight: false, tag: 'EnvironmentType' },
    { id: 'role', label: 'Profile Name', alignRight: false, tag: 'ProfileName' },
    { id: 'cameras', label: 'No Of Cameras Views', alignRight: false, tag: 'devicescount' },
    { id: 'CreatedOn', label: 'Created On', alignRight: false, tag: 'CreatedOn' },
    { id: 'MonitoringStartDate', label: 'Monitoring Start Date', alignRight: false, tag: 'MonitoringStartDate' },
    { id: 'MonitoringEndDate', label: 'Monitoring End Date', alignRight: false, tag: 'MonitoringEndDate' },
    { id: 'CreatedBy', label: 'Created By', alignRight: false, tag: 'CreatedBy' },
    { id: 'ClientType', label: 'Client Type', alignRight: false, tag: 'ClientType' },
    { id: 'isVerified', label: 'Event Send To', alignRight: false, tag: 'IsAgentBased' },
    { id: 'status', label: 'Status', alignRight: false, tag: 'Status' },
    // { id: 'Image', label: 'Client Image', alignRight: false,tag:'Image'},
    { id: '', alignRight: true },
    ];

    if (isReseller) {
        TABLE_HEAD = TABLE_HEAD.filter(col => col.id !== 'ClientType');
    }

    function applySortFilter(array, comparator, query) {
        // console.log(order,orderBy)
        // console.log(TABLE_HEAD)
        // console.log(array)
        const sortCol = TABLE_HEAD.filter(val => val.id === orderBy)
        //console.log(sortCol[0].tag)

        let key = sortCol.length > 0 ? sortCol[0].tag : ""

        let sortedData = []
        let stabilizedThis = [];
        if (key) {
            sortedData = [...array].sort((a, b) => {
                // if (a[key] < b[key]) return -1;
                // if (a[key] > b[key]) return 1;
                if (order === "asc") {
                    if (a[key] < b[key]) return -1;
                    if (a[key] > b[key]) return 1;
                } else if (order === "desc") {
                    if (a[key] > b[key]) return -1;
                    if (a[key] < b[key]) return 1;
                }
                return 0;
            });
        }
        // console.log(sortedData)
        stabilizedThis = sortedData.map((el, index) => [el, index]);

        if (key == "") {
            stabilizedThis = array.map((el, index) => [el, index]);
            stabilizedThis.sort((a, b) => {
                const order = comparator(a[0], b[0]);
                if (order !== 0) return order;
                return a[1] - b[1];
            });
        }

        if (query) {
            return filter(array, (_user) => ['ID', 'displayname', 'devicescount', 'Status'].map((ky) => _user[ky] !== null ? _user[ky] : '').join(' ').toLowerCase().indexOf(query.toLowerCase()) !== -1);
        }
        return stabilizedThis.map((el) => el[0]);
    }

    useEffect(() => {
        setClient(total)
    }, [total]);



    const handleRequestSort = (event, property) => {

        const isAsc = orderBy === property && order === 'asc';
        // console.log(isAsc)

        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };


    const filteredData = useMemo(() => {
        let filtered = total;

        // Filter by environmentType
        if (environmentType === "demo") {
            filtered = filtered.filter(c => Number(c.EnvironmentType) === 0);
        }
        if (environmentType === "production") {
            filtered = filtered.filter(c => Number(c.EnvironmentType) === 1);
        }

        // Filter by status
        if (statusFilter === "active") {
            filtered = filtered.filter(c => c.Status === 1);
        } else if (statusFilter === "inactive") {
            filtered = filtered.filter(c => c.Status === 0);
        }

        return filtered;
    }, [total, environmentType, statusFilter]);

    const filteredCounts = useMemo(() => {

        let filtered = total;

        // Filter by environmentType only
        if (environmentType === "demo") {
            filtered = filtered.filter(c => Number(c.EnvironmentType) === 0);
        }
        if (environmentType === "production") {
            filtered = filtered.filter(c => Number(c.EnvironmentType) === 1);
        }

        return {
            total: filtered.length,
            active: filtered.filter(c => c.Status === 1).length,
            inactive: filtered.filter(c => c.Status === 0).length,
        };

    }, [total, environmentType]);



    const handleActiveInActive = (status = 'all') => {
        setStatusFilter(status);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleFilterByName = (event) => {
        setFilterName(event.target.value);
    };

    const displayedClients = filteredData;
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - displayedClients.length) : 0;
    const filteredUsers = applySortFilter(displayedClients, getComparator(order, orderBy), filterName);
    const isUserNotFound = filteredUsers.length === 0;

    const [confirmalert, setAlert] = useState({
        title: '',
        content: '',
        open: false,
        id: null,
        status: null,
    });

    const handleAlertClose = () => setAlert({ ...confirmalert, open: false });

    const handleAlertOpen = (id, status) => {
        if (status === 'status' && Number(id.Status) === 0) {
            let content = status === 'status' ? 'Are you sure want to Active this record?' : 'Are you sure want to delete this record permanently?';
            let btn = status === 'status' ? "Yes, Active record!" : "Yes, delete record!";
            let upStatus = status === 'delete' ? 2 : 1;
            setAlert({
                title: btn,
                content: content,
                open: true,
                id: id.ID,
                status: upStatus,
            });
        } else {
            let content = status === 'status' ? 'Are you sure want to inactive this record?' : 'Are you sure want to delete this record permanently?';
            let btn = status === 'status' ? "Yes, inactive record!" : "Yes, delete record!";
            let upStatus = status === 'delete' ? 2 : 0;
            setAlert({
                title: btn,
                content: content,
                open: true,
                id: id.ID,
                status: upStatus,
            });
        }
    };

    const handleStatus = (id, status) => {
        if (status === 2) {
            client.deleteClient(id, (response) => {
                if (response.status === 200) {
                    removeClientFromState(id);
                    handleAlertClose();
                }
            });
        } else {
            client.updateSataus(id, status, (response) => {
                if (response.status === 200) {
                    reloadClientsData();
                    handleAlertClose();
                }
            });
        }
    };

    const handleEnvironmentType = (event) => {
        setEnvironmentType(event.target.value);
        setPage(0);
    }

    useEffect(() => {
        setStatusFilter("all");
    }, [environmentType]);

    return (
        <Box>
            <ClientAlert
                alert={confirmalert.open}
                handleAlertClose={handleAlertClose}
                title={confirmalert.title}
                content={confirmalert.content}
                id={confirmalert.id}
                status={confirmalert.status}
                handleStatus={handleStatus}
            />

            <ClientReport
                total={filteredCounts.total}
                active={filteredCounts.active}
                inactive={filteredCounts.inactive}
                listHandler={handleActiveInActive}
            />

            <Grid container spacing={2}>
                {(tab === "us") &&
                    <Grid item md={2} sx={{ ml: 2, mt: 2.5 }}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-labell">Environment Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={environmentType}
                                label="Environment Type"
                                onChange={handleEnvironmentType}
                            >
                                <MenuItem sx={{
                                    '&.Mui-selected': {
                                        backgroundColor: 'rgba(143, 148, 148, 0.91)'
                                    }
                                }} value="all">All</MenuItem>
                                <MenuItem sx={{
                                    '&.Mui-selected': {
                                        backgroundColor: 'rgba(143, 148, 148, 0.91)'
                                    }
                                }} value="demo">Demo</MenuItem>
                                <MenuItem sx={{
                                    '&.Mui-selected': {
                                        backgroundColor: 'rgba(143, 148, 148, 0.91)'
                                    }
                                }} value="production">Production</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                }
                <Grid item md={3}>
                    <UserListToolbar sx={{ backgroundColor: (theme) => theme.palette.background.neutral }}  numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />
                </Grid>
            </Grid>
            
            <Scrollbar>
                <TableContainer sx={{ minWidth: 800, maxHeight: 550 }}>
                    <Table style={{ position: 'sticky', top: '0', flexDirection: 'column' }}>
                        <ClientListHead
                            order={order}
                            orderBy={orderBy}
                            headLabel={TABLE_HEAD}
                            rowCount={clients.length}
                            numSelected={selected.length}
                            onRequestSort={handleRequestSort}
                        />
                        <TableBody sx={{ '& .MuiTableCell-root': { whiteSpace: 'nowrap' } }}>
                            {filteredUsers.map((row, inc) => {
                                const { ID, displayname, Location, ProfileName, devicescount, CreatedBy, CreatedOn, MonitoringStartDate, MonitoringEndDate, EnvironmentType, ClientType, IsAgentBased, Status, Image, LogoUrl } = row;
                                const isItemSelected = selected.indexOf(displayname) !== -1;

                                return (
                                    <TableRow
                                        hover
                                        key={inc}
                                        tabIndex={-1}
                                        role="checkbox"
                                        selected={isItemSelected}
                                        aria-checked={isItemSelected}
                                    >
                                        <TableCell>{(inc + (page * rowsPerPage)) + 1}</TableCell>
                                        <TableCell align="left">{ID}</TableCell>
                                        <TableCell component="th" scope="row" padding="none">
                                            {displayname && (
                                                <Stack direction="row" alignItems="center" spacing={2}>
                                                    {/* <Avatar sx={{ bgcolor: getColor[displayname[0].toLowerCase()] }}>{displayname[0].toUpperCase()}</Avatar> */}
                                                    <Avatar
                                                        sx={{
                                                            width: 60,
                                                            height: 60,
                                                            bgcolor: '#ffffff',
                                                        }}
                                                        imgProps={{ style: { objectFit: 'contain' } }}
                                                        src={LogoUrl ? addCacheVersion(LogoUrl, logoCacheVersion) : "/static/mock-images/avatars/default.png"}
                                                        >
                                                        {!LogoUrl && displayname[0].toUpperCase()}  
                                                    </Avatar>
                                                    <Typography variant="subtitle2" noWrap>
                                                        {displayname}
                                                    </Typography>
                                                </Stack>
                                            )}
                                        </TableCell>

                                        <TableCell align="left">{Location}</TableCell>
                                        <TableCell align="left">{EnvironmentType === 0 ? 'Demo' : 'Production'}</TableCell>

                                        <TableCell component="th" scope="row" padding="none">
                                            <Stack direction="row" alignItems="center" spacing={2}>
                                                <Avatar
                                                    sx={{
                                                            width: 60,
                                                            height: 60,
                                                            bgcolor: '#ffffff',
                                                        }}
                                                    imgProps={{ style: { objectFit: 'contain' } }}
                                                    src={Image ? Image : "/static/mock-images/avatars/default.png"}  
                                                    >
                                                    {!Image && ProfileName ? ProfileName[0]?.toUpperCase() : ''}
                                                </Avatar>
                                                <Typography variant="subtitle2" noWrap>
                                                    {ProfileName}
                                                </Typography>
                                            </Stack>
                                        </TableCell>


                                        <TableCell align="left">{devicescount}</TableCell>
                                        <TableCell align="left">{formatCreatedOn(CreatedOn)}</TableCell>
                                        <TableCell align="left">{MonitoringStartDate ?? ''}</TableCell>
                                        <TableCell align="left">{MonitoringEndDate ?? ''}</TableCell>
                                        <TableCell align="left">{CreatedBy}</TableCell>
                                        {!isReseller && <TableCell align="left">{ClientType}</TableCell>}
                                        <TableCell align="left">{IsAgentBased === 1 ? 'Tier 1' : 'Client'}</TableCell>
                                        <TableCell align="left">
                                            <Label variant="ghost" color={Status === 1 ? 'success' : 'error'}>
                                                {Status === 1 ? 'Active' : 'In Active'}
                                            </Label>
                                        </TableCell>
                                      
                                        {/* <TableCell
                                        align="center"
                                        sx={{ width: 80, height: 80, p: 1 }}
                                        >
                                        {Image ? (
                                            <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: "100%",
                                                height: "100%",
                                            }}
                                            >
                                            <img
                                                src={Image}
                                                alt="Client Image"
                                                onError={() => setImageError(true)}
                                                style={{
                                                maxWidth: "60px",
                                                maxHeight: "60px",
                                                objectFit: "contain",
                                                }}
                                            />
                                            </Box>
                                        ) : (
                                            <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: "100%",
                                                height: "100%",
                                            }}
                                            >
                                            <ImageNotSupportedIcon fontSize="small" />
                                            </Box>
                                        )}
                                        </TableCell> */}

                                     
                                     

                                        <TableCell align="right">
                                            <ClientMoreMenu
                                                handleAlertOpen={handleAlertOpen}
                                                handleDialog={handleDialog}
                                                handleMoremenu={handleMoremenu}
                                                removeClientFromState={removeClientFromState}
                                                row={row}
                                            />
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 53 * emptyRows }}>
                                    <TableCell colSpan={10} />
                                </TableRow>
                            )}
                        </TableBody>
                        {isLoaded && isUserNotFound && total.length===0 && (
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                                        <Box
                                            sx={{
                                                width: '100%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                No data
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )}

                        { !isLoaded && (
                             <TableBody>
                             <TableRow>
                                 <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                                     <CircularProgress/>
                                 </TableCell>
                             </TableRow>
                           </TableBody>
                        )}
                    </Table>
                </TableContainer>
            </Scrollbar>

            {/* <TablePagination
                rowsPerPageOptions={[100, 300, 500]}
                component="div"
                count={clients.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}
        </Box>
    );
}
